module.exports = __webpack_public_path__ + "img/91.5f0c8916.jpg";